<template>
  <div class="newBarA">
    <!-- 区域 -->
    <div class="newBarV" @mouseleave="enterIndex = -1">
      <!-- 包裹 -->
      <div
        :class="[
          enterIndex == index || selectIndex == index ? 'activeSon' : '',
          'newBarB',
        ]"
        v-for="(items, index) in navList"
        :key="index"
        @mouseenter="mouseOverOne(index)"
      >
        <p
          :class="[selectIndex == index ? 'newBarB_active' : '', 'newBarB_p']"
          @click="navtoPage(items, index)"
        >
          {{ items.label }}
        </p>
        <!-- 浮动区域    -->
        <div
          class="newBarF"
          v-show="
            enterIndex == index && items.children.length && enterIndex != 0
          "
        >
          <div
            v-for="(item, key) in items.children"
            :key="key"
            :class="[overIndex == key ? 'newHoverShow' : '']"
            @mouseenter="overIndex = key"
          >
            <div class="newBarI" @click.stop="navToList(items, item, index)">
              <p>{{ item.label }}</p>
              <img :src="rightIcon" style="width: 16px; height: 16px" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索框 -->
    <div style="width: 116px">
      <search></search>
    </div>
  </div>
</template>

<script>
import { getNavList } from "../api/moudles/user.js";
import search from "./search.vue";
export default {
  data() {
    return {
      enterIndex: -1,
      selectIndex: -1,
      overIndex: -1,
      navList: [],
      rightIcon: require("../assets/img/webIndex/right.png"),
    };
  },
  components: {
    search,
  },
  props: {},
  watch: {},
  created() {
    this.getNavList();
    if (localStorage.getItem("navIndex")) {
      this.selectIndex = parseInt(localStorage.getItem("navIndex"));
    }
  },
  methods: {
   
    // 一级栏目悬浮
    mouseOverOne(index) {
      this.enterIndex = index;
      this.overIndex = -1;
    },
    // 导航栏
    async getNavList() {
      this.topNav = false;
      await getNavList({
        data: {
          position: 1,
        },
        success: (res) => {
          console.log("导航栏", res);
          this.navList = res.data;
        },
      });
    },
    navtoPage(items, index) {
      this.selectIndex = index;
      localStorage.setItem("navIndex", index);
      localStorage.removeItem("columnName0");
      // 子网站
      if (items.model == "18") {
        localStorage.setItem("columnCode", items.key);
        localStorage.setItem("columnName", items.label);
        localStorage.setItem("columnStatus", items.model);
        // 首页
        this.$router.push("/webIndex");
      }
      // 资讯类、下载类
      if (items.model == "1" || items.model == "8") {
        localStorage.setItem("columnCode", items.key);
        localStorage.setItem("columnName", items.label);
        localStorage.setItem("columnStatus", items.model);

        this.$router.push({
          name: "empty",
        });
      }
      // 外链
      if (items.model == "0") {
        this.navList.forEach((item) => {
          if (item.label == "行业动态") {
            localStorage.setItem("columnCode", item.key);
            localStorage.setItem("columnName", item.label);
            localStorage.setItem("columnStatus", item.model);
          }
        });
        if (items.link) {
          window.open(items.link, "_self");
        }
      }
      // 视频
      if (items.model == "12") {
        localStorage.setItem("columnCode", items.key);
        localStorage.setItem("columnName", items.label);
        localStorage.setItem("columnStatus", items.model);
        this.$router.push({
          name: "courseLearn",
          query: {
            columnCode: items.key,
          },
        });
      }
      // 业务活动mode7-模型是单页
      if (items.model == "7") {
        localStorage.setItem("columnCode", items.key);
        localStorage.setItem("columnName", items.label);
        localStorage.setItem("columnStatus", items.model);
        this.$router.push({
          name: "activitiesList",
        });
      }
      // 实际页面
      if (items.model == "4") {
        if (this.$phoneSize()) {
          this.$router.push(`/phoneIndex/${items.link}`);
        } else {
          this.$router.push(`/${items.link}`);
        }
      }
    },
    // to二级list
    navToList(father, child, index) {
      this.selectIndex = index;
      localStorage.setItem("navIndex", index);
      // 资讯或者文件下载
      if (child.model == "1" || child.model == "8") {
        localStorage.setItem("columnCode", child.key);
        localStorage.setItem("columnName", child.label);
        localStorage.setItem("columnStatus", child.model);
        localStorage.setItem("columnName0", father.label);
        localStorage.setItem("columnCode0", father.key);

        this.$router.push({
          name: "empty",
        });
      }
      // 实际页面
      if (child.model == "4") {
        if (this.$phoneSize()) {
          this.$router.push(`/phoneIndex/${child.link}`);
        } else {
          this.$router.push(`/${child.link}`);
        }
      }
      // 外链
      if (child.model == "0") {
        if (child.link) {
          window.open(child.link, "_self");
        }
      }
    },
  },
};
</script>

<style scoped>
.newBarA {
  width: 770px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.newBarV {
  width: 630px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.newBarB {
  flex: 1;
  max-width: 140px;
  box-sizing: border-box;
  height: 50px;
  text-align: right;
}

.newBarB_p {
  display: inline-block;
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
  padding: 10px 0px;
}

.newBarB:hover {
  cursor: pointer;
}

.newBarB_active {
  border-bottom: 4px solid #fff;
}

/* 浮动 */
/* 浮动 */
.newBarF {
  top: 100px;
  position: absolute;
  width: max-content;
  background-color: #fff;
  z-index: 999;
  box-shadow: 0px 0px 16px 0px rgb(0 0 0 / 10%);
  padding: 1.33rem 2.67rem;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 1rem;
  line-height: 1.58rem;
  cursor: pointer;
  box-sizing: border-box;
}

.newBarI {
  padding-top: 10px;
  width: fit-content;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
}

.newBarI img {
  margin-left: 1.33rem;
  visibility: hidden;
}

.newBarI:hover > img {
  visibility: visible;
}
.newBarI:hover p {
  color: #c01219;
}

/* 搜索 */
.headerSearch {
  width: 195px;
  height: 40px;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(24, 56, 90, 0.27);
  display: flex;
  cursor: pointer;
}

.headerSearch input {
  width: 192px;
  border-radius: 4px 0 0 4px;
  padding-left: 16px;
}
</style>
